import React from 'react'
import { InputWithSuffix } from '@/components/ui/input-group'
import { Label } from '@/components/ui/label'

const ptSuffix = <span className="text-sm leading-4 text-muted-foreground tabular-nums">pt</span>

type PreferenceFieldProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  onBlur: () => void
  error: boolean
  title: string
  /** Shown under the input while `error` is true. */
  rangeLabel: string
}

/** One labelled point-value field of the Preferences dialog, with its range error line. */
export const PreferenceField: React.FC<PreferenceFieldProps> = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  title,
  rangeLabel,
}) => {
  return (
    <div className="flex min-h-px min-w-[98px] max-w-[500px] flex-1 flex-col gap-2">
      <Label
        htmlFor={id}
        className="w-min min-w-full text-sm font-medium leading-none text-foreground"
      >
        {label}
      </Label>
      <InputWithSuffix
        id={id}
        type="text"
        inputMode="numeric"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        suffix={ptSuffix}
        error={error}
        className="h-9 px-3 py-1 pr-10 text-sm leading-5 shadow-xs"
        placeholder=""
        title={title}
        autoComplete="off"
      />
      {error ? (
        <p className="w-full text-sm font-medium leading-5 text-destructive">{rangeLabel}</p>
      ) : null}
    </div>
  )
}
